<template>
    <div class="all">
        <!-- 会员导航 -->
        <vipMenu></vipMenu>
        <div class="warp mt20">
            <div class="warp-header">
                <h2>会员兑换</h2>
            </div>
            <div class="warp-body clearfix">
                <!-- 建方案 -->
                <div class="form-warp input-list field fl">
                    <div class="item clearfix">
                        <span class="name fl">会员兑换:</span>
                        <div class="input-father">
                            <input class="input-text" v-model.trim="couponCode" type="text" placeholder="" maxLength="16"/>
                        </div>
                    </div>
                    <div class="form-btn">
                        <button class="btn save btn-jbblue" @click="vipCoupon();">立即兑换</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 兑换提示 -->
        <Dialog ref="couponModal" :callback="enterCoupon" type="confirm">
            <div slot="mdBox">
                <p class="ac">{{$parent.memberType === 0 ? '兑换后，将会关闭试用会员权限,' : ''}}是否确认兑换会员？</p>
            </div>
        </Dialog>
        <!-- 兑换成功提示 -->
        <Dialog ref="sucessModal" type="alert">
            <div slot="mdBox">
                <p>兑换成功</p>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import vipMenu from './vipMenu.vue';
export default {
    components:{Dialog,vipMenu},
    data() {
        return {
            couponCode:''
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            
        }) 
    },
    created() {
		
    },
    methods: {
        // 兑换
        vipCoupon () {
            let that = this;
            if(that.couponCode == '' || that.couponCode.length != 16){
                that.$utils.alertText('请输入正确的16位优惠券码');
                return;
            }
            that.$refs.couponModal.showMaskFun();
        },
        // 确认兑换
        enterCoupon () {
            let that = this;
            let datas = {cardCode:that.couponCode};
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.post('user/member/member-exchange',{data:datas},r =>{
                that.$parent.showLoad = false;
                that.$refs.couponModal.closeMask();
                that.$parent.returnCode(r,function(){
                    that.$parent.getUserInformation();
                    that.$parent.alertTips(r.msg);
                });
            })
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/vipExchange.vue